.room {
  --mobile-edge: #25160e;
  background: radial-gradient(
    ellipse at 50% 42%,
    #362319 0%,
    #1b120d 43%,
    #0b0806 73%,
    #030302 100%
  );
}

.room .scene::after {
  content: '';
  position: absolute;
  z-index: 2;
  inset: 0;
  pointer-events: none;
  background: radial-gradient(circle at 47% 34%, rgba(82, 209, 201, 0.035), transparent 28%);
}

.projectScreen {
  position: absolute;
  z-index: 5;
  width: 29.3%;
  height: 28%;
  top: 23.3%;
  left: 33.2%;
  overflow: hidden;
  color: #f2e9bf;
  background: rgba(3, 7, 8, 0.7);
  box-shadow:
    0 0 2cqw rgba(99, 238, 102, 0.18),
    inset 0 0 2.8cqw rgba(99, 238, 102, 0.07);
  container-type: inline-size;
  transform-origin: center;
}

.projectScreen::after {
  content: '';
  position: absolute;
  z-index: 8;
  inset: 0;
  pointer-events: none;
  opacity: 0.12;
  background: repeating-linear-gradient(0deg, transparent 0 4px, #7ce0d1 5px);
}

.projectScreenOn {
  animation: projectTvOn 0.32s steps(4, end);
}
.projectScreenOff {
  background: #020303;
  animation: projectTvOff 0.24s steps(4, end);
}

.teletextPanel {
  --project-accent: #f3d84b;
  position: relative;
  z-index: 2;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 4cqw 5cqw 3.5cqw;
  overflow: hidden;
  background: #07151a;
  text-shadow: 0.3cqw 0.3cqw 0 #000;
  animation: teletextTune 0.34s steps(5, end) both;
}

.teletextPanel header {
  display: flex;
  justify-content: space-between;
  padding-bottom: 2.2cqw;
  border-bottom: 1.25cqw solid var(--project-accent);
  color: var(--project-accent);
  font-size: clamp(5px, 2.2cqw, 9px);
}

.teletextPanel h2 {
  flex: 0 0 auto;
  min-height: 1.2em;
  margin: 2.7cqw 0 2.3cqw;
  overflow: hidden;
  color: #fff5c9;
  font:
    400 clamp(9px, 5cqw, 22px) / 1.15 'Press Start 2P',
    monospace;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.projectMeta {
  display: grid;
  grid-template-columns: auto 1fr auto auto;
  gap: 2.5cqw;
  margin-bottom: 2.2cqw;
  padding: 1.8cqw 2.2cqw;
  background: var(--project-accent);
  color: #071013;
  font-size: clamp(5px, 1.85cqw, 8px);
  text-shadow: none;
}

.projectMeta span {
  opacity: 0.65;
}

.teletextPanel h3 {
  margin: 0 0 1cqw;
  color: var(--project-accent);
  font-size: clamp(5px, 1.85cqw, 8px);
}

.projectStack,
.projectDescription {
  margin: 0 0 1.7cqw;
  color: #d8d1ad;
  font:
    700 clamp(7px, 1.9cqw, 10px) / 1.38 'Courier New',
    monospace;
}

.projectDescription {
  color: #a9b5a6;
}

.teletextPanel > a {
  width: max-content;
  flex: 0 0 auto;
  margin-top: auto;
  padding: 1.7cqw 2.2cqw;
  background: var(--project-accent);
  color: #071013;
  font-size: clamp(5px, 1.85cqw, 8px);
  text-shadow: none;
}

.teletextPanel > a:hover,
.teletextPanel > a:focus-visible {
  background: #fff5c9;
  outline: 0;
}

.offAir {
  height: 100%;
  display: grid;
  place-content: center;
  justify-items: center;
  gap: 4cqw;
  color: #39423b;
  text-align: center;
}

.offAir span {
  color: #63251f;
  font-size: 7cqw;
}
.offAir b {
  font-size: clamp(8px, 4.5cqw, 19px);
}
.offAir small {
  font-size: clamp(4px, 1.8cqw, 8px);
}

.noSignal {
  position: relative;
  height: 100%;
  display: grid;
  place-items: center;
  overflow: hidden;
}

.noSignal > i {
  position: absolute;
  inset: 0;
  background: url('/assets/v5-tv-static.png') no-repeat 0 0 / 800% 100%;
  animation: staticFrames 0.52s steps(7, end) infinite;
}

.noSignal > div {
  position: relative;
  z-index: 2;
  width: 76%;
  display: grid;
  justify-items: center;
  gap: 3.2cqw;
  padding: 5cqw;
  border: 1.2cqw solid #f3d84b;
  background: rgba(5, 11, 13, 0.92);
  color: #f5ebbd;
  text-align: center;
  box-shadow: 2cqw 2cqw 0 #000;
}

.noSignal span {
  color: #61d7ce;
  font-size: clamp(4px, 1.8cqw, 8px);
}
.noSignal b {
  color: #ff705d;
  font-size: clamp(8px, 4.4cqw, 18px);
}
.noSignal strong {
  font-size: clamp(7px, 3.2cqw, 14px);
  line-height: 1.55;
}
.noSignal small {
  color: #8ba39c;
  font-size: clamp(4px, 1.5cqw, 7px);
}

.remote {
  position: absolute;
  z-index: 10;
  left: 50%;
  top: 79.5%;
  width: 22cqw;
  aspect-ratio: 1347 / 462;
  background: url('/assets/v5-remote-base.png') no-repeat 0 0 / 100% 100%;
  transform: translate(-50%, -50%) rotate(-2deg);
  filter: drop-shadow(1cqw 1.5cqw 0 rgba(0, 0, 0, 0.64));
  image-rendering: pixelated;
}

.remoteButton {
  position: absolute;
  z-index: 2;
  aspect-ratio: 1;
  padding: 0;
  border: 0;
  outline: 0;
  background-color: transparent;
  background-repeat: no-repeat;
  background-position: 0 0;
  background-size: 300% 100%;
  cursor: pointer;
  image-rendering: pixelated;
}

.remotePower {
  left: 11.4%;
  top: -5%;
  width: 26%;
  background-image: url('/assets/v5-remote-power.png');
}
.remotePrev {
  left: 38.5%;
  top: -2%;
  width: 24%;
  background-image: url('/assets/v5-remote-left.png');
}
.remoteNext {
  left: 66.5%;
  top: -2%;
  width: 24%;
  background-image: url('/assets/v5-remote-right.png');
  transform: rotate(-1deg);
}
.remoteButton:hover,
.remoteButton:focus-visible {
  background-position: 50% 0;
}
.remoteButton.remoteButtonHalf {
  background-position: 50% 0;
}
.remoteButton.remoteButtonPressed {
  background-position: 100% 0;
}
.remoteButton:focus-visible {
  filter: drop-shadow(0 0 0.35cqw #f3d84b);
}

.remoteHint {
  position: absolute;
  z-index: 10;
  left: 50%;
  bottom: 6.5%;
  margin: 0;
  padding: 0.65cqw 1cqw;
  background: rgba(4, 8, 8, 0.84);
  color: #bdb38d;
  font-size: clamp(4px, 0.55cqw, 7px);
  transform: translateX(-50%);
}

@keyframes projectTvOn {
  0% {
    opacity: 0;
    transform: scaleY(0.015);
  }
  55% {
    opacity: 1;
    transform: scaleY(0.015);
  }
  100% {
    transform: scaleY(1);
  }
}
@keyframes projectTvOff {
  0% {
    opacity: 1;
    transform: scaleY(1);
  }
  70% {
    opacity: 1;
    transform: scaleY(0.015);
  }
  100% {
    opacity: 0.72;
    transform: scaleY(0.015);
  }
}
@keyframes teletextTune {
  0% {
    opacity: 0;
    translate: 0 -18%;
    filter: contrast(2);
  }
  35% {
    opacity: 0.45;
    translate: 0 9%;
  }
  70% {
    opacity: 0.8;
    translate: 0 -2%;
  }
  100% {
    opacity: 1;
    translate: 0 0;
    filter: contrast(1);
  }
}
@keyframes staticFrames {
  from {
    background-position: 0 0;
  }
  to {
    background-position: 100% 0;
  }
}

@keyframes idlePromptIn {
  0% {
    opacity: 0;
    transform: scaleY(0.03);
  }
  55% {
    opacity: 1;
    transform: scaleY(0.03);
  }
  100% {
    opacity: 1;
    transform: scaleY(1);
  }
}
@keyframes idlePromptBlink {
  50% {
    opacity: 0.45;
  }
}

@media (max-width: 680px) {
  .projectScreen {
    left: 29.4%;
    top: 14.5%;
    width: 46.2%;
    height: 22.4%;
  }
  .teletextPanel {
    padding: 3.4cqw 4.3cqw 3cqw;
  }
  .teletextPanel h2 {
    margin-block: 2.1cqw 1.8cqw;
  }
  .projectMeta {
    margin-bottom: 1.7cqw;
    padding-block: 1.3cqw;
  }
  .projectStack,
  .projectDescription {
    margin-bottom: 1.2cqw;
    line-height: 1.28;
  }
  .teletextPanel > a {
    padding-block: 1.35cqw;
  }
  .remote {
    top: 69%;
    width: 32cqw;
  }
  .remoteHint {
    bottom: 10%;
    padding: 1.1cqw 1.7cqw;
    font-size: clamp(4px, 1cqw, 6px);
  }
}

@media (prefers-reduced-motion: reduce) {
  .idlePrompt,
  .idlePrompt b,
  .projectScreen,
  .teletextPanel,
  .noSignal > i {
    animation-duration: 0.01ms;
    animation-iteration-count: 1;
  }
}
